import type { Locale } from '@/i18n'

interface Company {
  name: string
  logo?: string
  square?: boolean
}

const COMPANY = {
  cern: { name: 'CERN', logo: '/logos/cern.svg', square: true },
  esa: { name: 'ESA', logo: '/logos/esa.svg' },
  mckinsey: { name: 'McKinsey Digital', logo: '/logos/mckinsey.svg' },
  morganStanley: { name: 'Morgan Stanley', logo: '/logos/morgan-stanley.svg' },
  erste: { name: 'Erste Investment', logo: '/logos/erste.svg' },
  otp: { name: 'OTP Bank', logo: '/logos/otp.svg' },
  auchan: { name: 'Auchan', logo: '/logos/auchan.svg' },
  sanofi: { name: 'Sanofi', logo: '/logos/sanofi.svg' },
  ge: { name: 'GE Medical Systems', logo: '/logos/ge.svg', square: true },
  manifestOs: { name: 'Manifest OS', logo: '/logos/manifest-os.png' },
  sweco: { name: 'Sweco', logo: '/logos/sweco.png' },
  nsn: { name: 'Nokia Siemens Networks', logo: '/logos/nsn.svg', square: true },
  smartx: { name: 'Smartx' },
  uibFactor: { name: 'UIB Factor' },
  paycap: { name: 'Paycap' },
  starschema: { name: 'Starschema', logo: '/logos/starschema.png', square: true },
  blackbelt: { name: 'Blackbelt' },
  scaler: { name: 'Scaler' },
  cardoHealth: { name: 'Cardo Health' },
  cyberg: { name: 'Cyberg' },
  merigo: { name: 'Merigo' },
} satisfies Record<string, Company>

export const COMPANIES: Record<Locale, readonly Company[]> = {
  en: [
    COMPANY.cern,
    COMPANY.esa,
    COMPANY.mckinsey,
    COMPANY.morganStanley,
    COMPANY.erste,
    COMPANY.otp,
    COMPANY.auchan,
    COMPANY.sanofi,
    COMPANY.ge,
    COMPANY.manifestOs,
    COMPANY.sweco,
    COMPANY.nsn,
    COMPANY.smartx,
    COMPANY.uibFactor,
    COMPANY.paycap,
    COMPANY.starschema,
    COMPANY.blackbelt,
    COMPANY.scaler,
    COMPANY.cardoHealth,
    COMPANY.cyberg,
    COMPANY.merigo,
  ],
  hu: [
    COMPANY.auchan,
    COMPANY.otp,
    COMPANY.erste,
    COMPANY.uibFactor,
    COMPANY.starschema,
    COMPANY.cern,
    COMPANY.esa,
    COMPANY.mckinsey,
    COMPANY.morganStanley,
    COMPANY.ge,
    COMPANY.nsn,
    COMPANY.sanofi,
    COMPANY.sweco,
    COMPANY.manifestOs,
    COMPANY.smartx,
    COMPANY.paycap,
    COMPANY.blackbelt,
    COMPANY.scaler,
    COMPANY.cardoHealth,
    COMPANY.cyberg,
    COMPANY.merigo,
  ],
}

interface LogosCopy {
  sectionLabel: string
  subtext: string
  logoAltSuffix: string
  moreLabel: string
}

export const LOGOS_COPY: Record<Locale, LogosCopy> = {
  en: {
    sectionLabel: 'Companies',
    subtext: 'Through direct contracts, partners, and past engineering roles.',
    logoAltSuffix: 'logo',
    moreLabel: 'Also:',
  },
  hu: {
    sectionLabel: 'Akiknek dolgoztunk',
    subtext:
      'Van, akivel közvetlenül szerződtünk, van, akihez partneren keresztül jutottunk el, és van, aki még a korábbi pályafutásból ismer minket.',
    logoAltSuffix: 'logó',
    moreLabel: 'Továbbá:',
  },
}
